export var TOASTR_SEVERITY_ERROR = 'error';
export var TOASTR_SEVERITY_SUCCESS = 'success';
export var TOASTR_SEVERITY_SUCCESS_PERSISTENT = 'success-persistent';
export var TOASTR_SEVERITY_WARNING = 'warning';